import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="row m-0 p-0">
      <div
        className="col-md-12"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "12px",
          fontSize: "14px",
          backgroundColor: "black",
          color: "#fff",
        }}
      >
        <span>
          Copyright &copy; {currentYear} | Design & Developed By{" "}
          <a
            href="https://www.technoaarv.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: "pointer",
              color: "white",
              textDecoration: "none"
            }}
            onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
            onMouseOut={(e) => (e.target.style.textDecoration = "none")}
          >
            TechnoAarv
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;
